/* eslint-disable function-paren-newline */
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFlattenCompanyList } from 'pages/listDetail/hooks/useFlattenCompanyList';
import { sharedCompanyListV2Api } from 'services/sharedCompanyListV2';
import { isActiveSyncSelector, networksSelector } from '../../../redux/selectors';
import { getCompanyColumns } from '../components/table/getCompanyColumns';
import { useTableRows } from './useCompanyTableRows';
import { useFetchContacts } from './useFetchContacts';

export const useCompanyTable = ({ sharedList, user }) => {
  const ref = useRef(null);
  const networks = useSelector(networksSelector);
  const networkOptions =
    networks?.networks && !user.isOnlyAlly
      ? Object.entries(networks.networks).map(([id, network]) => ({
          label: network.name,
          value: id,
        }))
      : [];
  networkOptions.unshift({
    label: 'My contacts',
    value: 'my-contacts',
  });
  const [selectedNetwork, setSelectedNetwork] = useState(networkOptions[0]);

  const companiesColumns = getCompanyColumns(new Set([]), selectedNetwork.value !== 'my-contacts');
  const { data, contactsCount, isLoading, isFetching, queryParams, setQueryParams, networkId } = useFetchContacts({
    contactsSource: selectedNetwork.value,
    user,
    sharedList,
  });

  const companies = useFlattenCompanyList(data);
  const isActiveSync = useSelector(isActiveSyncSelector);

  const tableRows = useTableRows({
    companies,
    sharedList,
    contactsSource: selectedNetwork.value,
    network: {
      id: networkId,
    },
    isActiveSync,
  });
  const totalItems = data?.meta?.queryTotal;
  const currentPage = Math.ceil(data?.ids?.length / 10);
  const hasMore = currentPage + 1 <= Math.ceil(data?.meta?.queryTotal / 10);
  const initialSortBy = {
    id: 'name',
    desc: true,
  };

  const dispatch = useDispatch();
  const persistColumnKey = `${sharedList.id}-${selectedNetwork.value}-companies-columns`;

  const onChangeContactsSelector = (value) => {
    dispatch(sharedCompanyListV2Api.util.resetApiState());

    setSelectedNetwork(value);

    setTimeout(() => {
      ref.current?.api.refreshHeader();
    }, 100);
  };

  const onLoadMore = () => {
    setQueryParams({
      ...queryParams,
      page: currentPage + 1,
    });
  };

  return {
    companiesColumns,
    isLoading,
    isFetching,
    queryParams,
    tableRows,
    totalItems,
    hasMore,
    initialSortBy,
    networkOptions,
    selectedNetwork,
    contactsCount,
    onLoadMore,
    onChangeContactsSelector,
    isActiveSync,
    ref,
    persistColumnKey,
  };
};
